



















































































































































































import Vue from "vue";
import Modal from "@/components/Modal/Modal.vue";
import { store } from "@/store/store";
import { Device } from "@/store/modules/Device/interface";
import Map from "@/components/Map/Map.vue";
import { ApiResponse, FormType, IMapDataDefinition, PickStr } from "@/types/types";
import { LatLng } from "leaflet";
import Utils from "@/utils/utils";
import { Response_ } from "@/plugins/axios/response";

type ButtonKeys = "theoretical" | "real" | "polygon" | "angle";

interface PosteCreateModalData {
  mounted: boolean;
  loading: boolean;
  buttons: { [key in ButtonKeys]: { value: boolean; color: string } };
  form: PickStr<any>;
}

export default Vue.extend({
  name: "PosteCreateModal",
  components: {
    Modal,
    Map
  },
  props: {
    poste_id: {
      type: String || undefined,
      default: undefined
    },
    survey_id: {
      type: String
    },
    should_display: {
      type: Boolean,
      default: false
    },
    onAction: {
      type: Function,
      default: () => undefined
    },
    onCreateOrModify: {
      type: Function,
      default: () => undefined
    }
  },
  data(): PosteCreateModalData {
    return {
      mounted: false,
      loading: false,
      buttons: {
        theoretical: { value: false, color: "var(--button-no-color)" },
        real: { value: false, color: "var(--button-yes-color)" },
        polygon: { value: false, color: "var(--alyce-orange)" },
        angle: { value: false, color: "blue" }
      },
      form: this.$props.poste_id
        ? { ...store.getters.POSTE_BY_ID[this.$props.poste_id] }
        : {
            survey: this.$props.survey_id,
            name_poste: "",
            typology: "",
            theoretical_location: null,
            real_location: null,
            polygon_location: null,
            angle_location: null,
            material: null,
            comment: ""
          }
    };
  },
  mounted() {
    this.mounted = true;
  },
  methods: {
    async should_validate() {
      this.loading = true;
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        const request_result = await this.onCreateOrModify(
          this.$props.poste_id ? FormType.UPDATE : FormType.CREATE,
          this.form
        );
        if (
          (request_result as Response_).status === ApiResponse.CREATED ||
          (request_result as Response_).status === ApiResponse.SUCCESS
        ) {
          this.onAction({
            type: "SUCCESS",
            title: "Poste",
            content: (request_result as Response_).message
          });
          this.loading = false;
          this.should_close();
          return;
        } else {
          this.onAction({
            type: "ERROR",
            title: "Erreur",
            content: (request_result as Response_).message
          });
        }
      }
      this.loading = false;
    },
    should_close() {
      this.$emit("close");
    },
    changeButtonColor(button_name: ButtonKeys): void {
      const button_clicked = this.buttons[button_name];
      Object.keys(this.buttons).forEach((button_name_) => {
        if (button_name_ !== button_name) {
          this.buttons[button_name_ as ButtonKeys].value = false;
        }
      });
      button_clicked.value = !button_clicked.value;
    },
    button_color(button_name: ButtonKeys): string {
      return !this.buttons[button_name].value ? this.buttons[button_name].color : "black";
    },
    onClickedMap(latlng: LatLng): void {
      let button_clicked = undefined;
      Object.keys(this.buttons).forEach((button_name) => {
        if (this.buttons[button_name as ButtonKeys].value) button_clicked = button_name as ButtonKeys;
      });
      if (button_clicked) {
        if (button_clicked === "theoretical" || button_clicked === "real") {
          this.pointLocationModification(button_clicked, latlng);
        } else if (button_clicked === "polygon") {
          this.polygonLocationModification(latlng);
        } else if (button_clicked === "angle") {
          this.angleLocationModification(latlng, true);
        }
      }
    },
    onMouseOver(latlng: LatLng) {
      let button_clicked = undefined;
      Object.keys(this.buttons).forEach((button_name) => {
        if (this.buttons[button_name as ButtonKeys].value) button_clicked = button_name as ButtonKeys;
      });
      if (button_clicked === "angle") {
        this.angleLocationModification(latlng, false);
      }
    },
    pointLocationModification(button_name: ButtonKeys, latlng: LatLng): void {
      let location = this.form[button_name + "_location"];
      if (location === undefined || location === null) {
        this.form[button_name + "_location"] = {
          longitude: latlng.lng,
          latitude: latlng.lat
        };
      } else {
        location.longitude = latlng.lng;
        location.latitude = latlng.lat;
      }

      if (button_name === "real") {
        this.form.angle_location = null;
      }
      this.resetButtons();
    },
    polygonLocationModification(latlng: LatLng): void {
      let location = this.form.polygon_location;
      if (location === undefined || location === null) {
        this.form.polygon_location = [
          {
            longitude: latlng.lng,
            latitude: latlng.lat
          }
        ];
      } else {
        location.push({
          longitude: latlng.lng,
          latitude: latlng.lat
        });
      }
    },
    angleLocationModification(latlng: LatLng, click: boolean): void {
      const angle = Utils.calculateAngle(
        this.form.real_location.latitude,
        this.form.real_location.longitude,
        latlng.lat,
        latlng.lng
      );
      const center = Utils.calculateFromDistanceAndAngleCoordinates(0.02, -angle + 90, 0, 0);
      const r = Utils.calculateFromDistanceAndAngleCoordinates(
        0.02,
        -angle + 135,
        center.latitude as number,
        center.longitude as number
      );
      const l = Utils.calculateFromDistanceAndAngleCoordinates(
        0.02,
        -angle + 45,
        center.latitude as number,
        center.longitude as number
      );
      r.longitude += this.form.real_location.longitude;
      l.longitude += this.form.real_location.longitude;
      r.latitude += this.form.real_location.latitude;
      l.latitude += this.form.real_location.latitude;
      this.form.angle_location = [this.form.real_location, r, l];
      if (click) {
        this.buttons.angle.value = false;
      }
    },
    CancelSelection(button_name: ButtonKeys): void {
      let location = this.form[button_name + "_location"];
      if (location !== undefined && location !== null) {
        this.form[button_name + "_location"] = null;
      }

      if (button_name === "real") {
        this.form.angle_location = null;
      }
    },
    resetButtons(): void {
      Object.keys(this.buttons).forEach((button_name) => {
        this.buttons[button_name as ButtonKeys].value = false;
      });
    }
  },
  computed: {
    format_poste(): IMapDataDefinition {
      return {
        ...this.form,
        name: this.form.name_poste,
        location: this.form.real_location,
        comment: this.form.comment
      };
    },
    center(): any {
      return this.form.theoretical_location
        ? [this.form.theoretical_location.longitude, this.form.theoretical_location.latitude]
        : undefined;
    },
    zoom(): number {
      return this.form.theoretical_location ? 18 : 6;
    },
    materials(): Array<Device> {
      const material: Array<Device> = [];
      store.getters.DEVICE_ALL_ID.forEach((id: string) => {
        const mat = store.getters.DEVICE_BY_ID[id];
        if (
          ((mat.poste === undefined || mat.poste === null) &&
            store.getters.STATE_BY_ID[mat.state].name === "Réserve - Disponible") ||
          mat.poste === this.poste_id
        ) {
          material.push(mat);
        }
      });
      return material;
    },
    title(): string {
      return !this.poste_id ? "Créer un poste" : "Modifier un poste";
    },
    validateButtonName(): string {
      return !this.poste_id ? "Créer" : "Modifier";
    },
    nameRules(): Array<(value: string) => boolean | string> {
      return [(value: string): boolean | string => value.length > 0 || `Le champ nom est obligatoire.`];
    },
    typologyRules(): Array<(value: string) => boolean | string> {
      return [(value: string): boolean | string => value.length > 0 || `Le champ typologie est obligatoire.`];
    }
  },
  watch: {
    "form.typology": function (new_value: string, old_value: string) {
      if (new_value !== old_value) {
        this.form.polygon_location = undefined;
        this.form.angle_location = undefined;
        this.resetButtons();
      }
    }
  }
});
